<template>
<div class="policy">
  <!-- <div class="article" v-if="article" v-html="article.content"> -->
    <div class="policy-title">
        <a href="" title="网站首页">网站首页</a>
        >
        <a href="" title="政策动态">政策动态</a>
        >
        {{article.title}}
    </div>
    <div class="article" v-if="article">
      <h1>{{article.title}}</h1>
      <div class="article-info">
          <span class="author">{{article.author}}</span>
          <span class="time">{{article.created}}</span>
        </div>
        <div class="padding-top-20"></div>
        <div class="article-content" v-html="article.content">
        </div>
        <div class="article-footer">
          <div class="small-font-grey">来源:{{article.source}}</div>
          <div class="go-back"><i-button type="text" @click="$router.push({path:'/'})">返回文章列表</i-button></div>
        </div>
    </div>
      <!-- <div>{{article.brief}}</div>rsthrsths -->
  </div>
<!-- </div> -->
</template>

<script>
// import policyList from './policies.json'
export default {
  props: ['informationList'],
  data () {
    return {
      article: {}
      // policyList: {}
    }
  },
  watch: {
    'informationList': function (val) {
      if (val instanceof Array) {
        this.article = this.informationList.filter((item) => {
          return item.tid.toString() === this.$route.params.tid
        })[0]
      }
    },
    '$route.params.tid': function (val) {
      if (val) {
        this.article = this.informationList.filter((item) => {
          return item.tid.toString() === val
        })[0]
      }
    }
  },
  mounted () {
    if (this.$route.params.tid) {
      this.article = this.informationList.filter((item) => {
        return item.tid.toString() === this.$route.params.tid
      })[0]
      // return item.tid.toString() === this.$route.params.tid
    }
  }
}
</script>

<style lang="less" scoped>
.policy {
  // padding: 20px 5% 80px 5%;
  font-size: 13px;
  // min-width: 1200px;
  width: 96%;
  max-width: 1200px;
  margin: 0 auto;
}
.policy-title {
  padding: 20px 0 40px 0;
  a {
    color: #515a6e;
  }
}
.article {
  display: flex;
  flex-direction: column;
  align-items: center;
  .article-info {
    padding: 10px;
    width: 60%;
    text-align: center;
    border-bottom: 1px dashed #ccc;
  }
  .article-content {
    font-size: 16px;
    text-indent: 2em;
    line-height: 1.8em;
    margin: 20px 40px;
    p {
      margin: 4em 0 !important;
    }
  }
  .article-footer {
    margin-top: 40px;
    display: flex;
    width: 100%;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    .small-font-grey {
      color: #aaa;
    }
  }
  .article-content p {
  margin: 1.1em 0 !important;
}
}
</style>



// WEBPACK FOOTER //
// src/pages/policy/view.vue